/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { BACKGROUND_EFFECT_TYPE, } from "src/modules/pe-landing-module/data/interfaces"
import { getIScroll, useIScroll } from "src/modules/pe-landing-module/hooks/useIScroll"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { IFloatProps } from "./Float"

/* Protopia Ecosystem component */ 
export interface IFloatContainerProps extends IFloatProps {
    children: JSX.Element
}
const FloatContainer = ({ float, i, children, ...props }: IFloatContainerProps): JSX.Element => {
    const { id, isHidden, effect, parallax_y_offset, } = float
    const [zeroScroll, setZeroScroll] = useState<number>( 0 )
    const ref           = useRef(null) 
    const scroll        = useIScroll( ref, effect, zeroScroll ) 
    const { position }  = usePosition(float)
    
    
    
    useEffect(() => {        
        let transform: string = "", pOffset = 0
        switch ( effect ) {
            case BACKGROUND_EFFECT_TYPE.VERTICAL_PARALLAX: 
                pOffset = 0 // scroll * ( parallax_speed || -0.1 ) - ( parallax_y_offset || -100 ) + height
                break
            case BACKGROUND_EFFECT_TYPE.FIXED: 
                pOffset = scroll - ( parallax_y_offset || 0 )
                break
            default: 
                pOffset = 0
        }

        transform = `translateY(${ pOffset }px)`
        setZeroScroll( getIScroll( ref ) )
        addCSSClass(
            `float-${ id }-${ i }`,
            `.float-outer-${ id }-${ i } { 
                ${transform};
                width: ${getCssDemention(position.width)};
                height: ${getCssDemention(position.height)};
                z-index: ${position.z};
            }`
        ) 
        return () => {
            removeCSSClass(`float-${ id }-${ i }`)
        }
    },[ scroll ])

    
    if(isHidden) return <></>

    return <div 
        className={`landing-float-container float-outer-${ id }-${ i } `}  
        ref={ref}
    > 
        { children } 
    </div>
}
export default FloatContainer

 